import { render } from "./bookingCreate.vue?vue&type=template&id=0389812a&scoped=true"
import script from "./bookingCreate.vue?vue&type=script&lang=js"
export * from "./bookingCreate.vue?vue&type=script&lang=js"

import "./bookingCreate.vue?vue&type=style&index=0&id=0389812a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0389812a"]])

export default __exports__